// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"104":"a1ea140a","976":"aaac8be9"}[chunkId] + ".css";
};